<template>
  <rl-carousel v-model="slide" no-wrap static>
    <div slot-scope="{ wrapperStyles, slides: { count, active } }">
      <div class="overflow-hidden">
        <div v-bind="wrapperStyles" class="w-full">
          <slot></slot>
        </div>
      </div>
      <div
        class="absolute pt-8 ml-8 w-16 h-full pin-t pin-l flex items-stretch"
        @click="
          slide = active - 1
          triggerAnimation('Left')
        "
      >
        <div class="group flex-grow flex items-center justify-center cursor-pointer">
          <span
            class="control-chevron text-xl group-hover:text-3xl text-grey group-hover:text-grey-dark"
            :class="{ 'animate-left': animateLeft }"
          >
            <i class="fa fa-chevron-left"></i>
          </span>
        </div>
      </div>
      <div
        class="absolute pt-8 mr-8 w-16 h-full pin-t pin-r flex items-stretch"
        @click="
          slide = active + 1
          triggerAnimation('Right')
        "
      >
        <div class="group flex-grow flex items-center justify-center cursor-pointer">
          <span
            class="control-chevron text-xl group-hover:text-3xl text-grey group-hover:text-grey-dark"
            :class="{ 'animate-right': animateRight }"
          >
            <i class="fa fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </rl-carousel>
</template>

<script>
import { RlCarousel } from 'vue-renderless-carousel'

export default {
  name: 'arrow-carousel',
  components: {
    RlCarousel
  },
  data() {
    return {
      slide: 0,
      animateLeft: false,
      animateRight: false
    }
  },
  methods: {
    triggerAnimation(direction) {
      this[`animate${direction}`] = true

      setTimeout(() => {
        this[`animate${direction}`] = false
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
svg {
  transition: color 0.5s ease;
}

.control-chevron {
  transition: font-size 0.5s ease;

  &.animate-left {
    animation: animate-left 1s;
  }
  &.animate-right {
    animation: animate-right 1s;
  }
}

@keyframes animate-left {
  50% {
    transform: translateX(-10px);
  }
}
@keyframes animate-right {
  50% {
    transform: translateX(10px);
  }
}
</style>
